// add desktop nav as a css variable
// export const rootNavbarEl = (window.matchMedia("(min-width: 992px)").matches) ? document.querySelector('.navbar__wrapper--desktop') : document.querySelector('.navbar__wrapper--mobile')
const nav = document.querySelector(".navbar__wrapper.navbar__wrapper--desktop");
const siteUrl = window.globalJS.themeUrl;

export const setRootNavbarEl = () => {
	const rootNavbarEl = window.matchMedia("(min-width: 992px)").matches
		? document.querySelector('.navbar__wrapper--desktop')
		: document.querySelector('.navbar__wrapper--mobile');

	return rootNavbarEl;
}

export let rootNavbarEl = setRootNavbarEl();
window.addEventListener('resize', () => {
	rootNavbarEl = setRootNavbarEl();
});

// create css variable with nav height
const createNavbarVariable = () => {
	if (rootNavbarEl) {
		let navHeight = rootNavbarEl.clientHeight
		document.documentElement.style.setProperty('--navHeight', `${navHeight}px`)
	}
}
window.addEventListener('DOMContentLoaded', createNavbarVariable)
window.addEventListener('resize', createNavbarVariable)

// create icon with svg sprite
export const createFlag = (code) => {
	return `<svg><use xlink:href="${siteUrl}/assets/flags-spritemap.svg#${code}"></use></svg>`
}

export const createIcon = (code) => {
	return `<svg><use xlink:href="${siteUrl}/build/spritemap.svg#${code}"></use></svg>`
}
// /app/themes/tedee/build/spritemap

// cookie helpers
export function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

export function eraseCookie(name) {
	document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

// check if device is retina
export const isRetinaDisplay = () => {
	if (window.matchMedia) {
		const mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
		return (mq && mq.matches || (window.devicePixelRatio > 1));
	}
}

export const deleteHash = (url) => {
	let parts = url.split('#')
	return parts.shift()
}

export const addHash = (url, fragment) => {
	return url + "#" + fragment;
}

// get relative position for element
export const getRelativePosition = (el) => {
	if(!el) return;

	let pPos = el.parentNode.getBoundingClientRect(), // parent pos
		cPos = el.getBoundingClientRect(), // target pos
		pos = {};

	(pos.top = cPos.top - pPos.top + el.parentNode.scrollTop),
		(pos.right = cPos.right - pPos.right),
		(pos.bottom = cPos.bottom - pPos.bottom),
		(pos.left = cPos.left - pPos.left);

	return pos;
};

export const injectHubSpotScript = (rootEl) => {
	const hubspotScriptSrc = '//js.hsforms.net/forms/v2.js'
	const hubspotScriptTag = document.querySelector('#hubspot-form-library')
	const portalId = rootEl.dataset.portal
	const formId = rootEl.dataset.form

	if (!hubspotScriptTag) {
		let libraryScript = document.createElement('script')
		libraryScript.type = 'text/javascript'
		libraryScript.src = hubspotScriptSrc
		libraryScript.id = 'hubspot-form-library'

		document.head.appendChild(libraryScript)
		libraryScript.addEventListener('load', renderHubspotForm)
	} else {
		renderHubspotForm()
	}

	function renderHubspotForm() {

		// Check if the form script element already exists
		let hubspotFormScriptTag = rootEl.querySelector('#hubspot-form-script')
		if (!hubspotFormScriptTag) {
			let hubspotFormScript = document.createElement('script')
			hubspotFormScript.id = 'hubspot-form-script'
			const hubspotFormScriptBody = document.createTextNode(`
					hbspt.forms.create({
							region:'na1',
							portalId: '${portalId}',
							formId: '${formId}'
					});
				`)
			hubspotFormScript.appendChild(hubspotFormScriptBody)
			rootEl.appendChild(hubspotFormScript)
		}
	}
}

export const clickEvent = new MouseEvent('click', {
	view: window,
	bubbles: true,
	cancelable: true,
	clientX: 20
})
